import React from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../contexts/AdminAuthContext";
import { ShieldAlert, ArrowLeft, Home } from "lucide-react";
import { ROUTES } from "../../constants/routes";

export default function AdminAccessDenied({ requiredPermission }) {
  const navigate = useNavigate();
  const { role, adminUser } = useAdminAuth();

  return (
    <div className="admin-denied-container">
      <div className="admin-denied-icon">
        <ShieldAlert size={36} />
      </div>
      <h2 style={{ fontSize: "22px", fontWeight: 700, color: "#1e293b", marginBottom: "8px" }}>
        Access Denied
      </h2>
      <p style={{ color: "#64748b", maxWidth: "480px", marginBottom: "16px", fontSize: "14px", lineHeight: "1.5" }}>
        Your current role <strong>({role || "UNASSIGNED"})</strong> does not have authorization to view this page.
        {requiredPermission && (
          <span style={{ display: "block", marginTop: "6px", fontSize: "12px", color: "#ef4444" }}>
            Required permission: <code>{requiredPermission}</code>
          </span>
        )}
      </p>

      <div style={{ display: "flex", gap: "12px" }}>
        <button
          className="admin-btn admin-btn-secondary"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft size={16} /> Go Back
        </button>
        <button
          className="admin-btn admin-btn-primary"
          onClick={() => navigate(ROUTES.DASHBOARD)}
        >
          <Home size={16} /> Student Dashboard
        </button>
      </div>
    </div>
  );
}
